import { useEffect, useRef } from 'react';
import ReactJoyride, { EVENTS, Callback, ACTIONS } from 'react-joyride';
import { noop } from 'lodash';
import { IStep } from 'components/AppTour/tours';

interface AppTourProps {
  steps: IStep[];
  onTourClose?: () => void;
  tourTitle?: string;
  tourDescription?: string;
  continuous?: boolean;
  disableScrolling?: boolean;
  showProgress?: boolean;
  disableOverlay?: boolean;
  disableOverlayClose?: boolean;
  disableCloseOnEsc?: boolean;
  showSkipButton?: boolean;
  hasCompletedOnboarding?: boolean;
}

const AppTour: React.FC<AppTourProps> = ({
  steps = [],
  onTourClose = noop,
  continuous = true,
  showProgress = true,
  disableOverlayClose = false,
  disableCloseOnEsc = false,
  disableScrolling = false,
  disableOverlay = false,
  showSkipButton = false,
  hasCompletedOnboarding = false,
}: AppTourProps) => {
  const hasAutoSkipped = useRef(false);

  // The onboarding tutorial is disabled. For users who would have been shown
  // the tour (new accounts that haven't completed onboarding), automatically
  // proceed as if they tapped "Maybe Later" — onTourClose marks onboarding
  // complete so the tour never appears and won't re-prompt.
  useEffect(() => {
    if (!hasAutoSkipped.current && steps && steps.length > 1 && !hasCompletedOnboarding) {
      hasAutoSkipped.current = true;
      onTourClose();
    }
  }, [steps, hasCompletedOnboarding, onTourClose]);

  const handleJoyrideCallback: Callback = ({ action, type }) => {
    if (type === EVENTS.TOUR_END || action === ACTIONS.CLOSE) {
      onTourClose();
    }
  };

  return (
    <ReactJoyride
      steps={steps}
      run={false}
      showSkipButton={showSkipButton}
      callback={handleJoyrideCallback}
      continuous={continuous}
      disableScrolling={disableScrolling}
      showProgress={showProgress}
      disableOverlay={disableOverlay}
      disableOverlayClose={disableOverlayClose}
      disableCloseOnEsc={disableCloseOnEsc}
    />
  );
};

export default AppTour;
